<template>
  <layout-report-step
    :isDone="isDone"
    :title="header.title"
    :description="header.description"
    :image="header.image"
    :debug="header.debug"
  >
    <v-card flat max-width="500" class="pt-4">
      <numberplate-form
        class="mx-4"
        v-model="numberplate"
        :valid="valid"
        v-on:valid="setValid"
        :countryCode="countryCode"
      ></numberplate-form>
    </v-card>
  </layout-report-step>
</template>

<script lang="ts">
import NumberplateForm from "@/components/utility/NumberplateForm.vue";
import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { AssetEnum } from "@/lib/AssetRepository";
import { CountryCodeEnum } from "@/lib/enum/country-code.enum";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import ReportStepMixin from "@/mixins/ReportStepMixin.vue";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { ReportModule } from "@/store/modules/report.store";
import { Component } from "vue-property-decorator";

@Component({
  components: {
    NumberplateForm,
    LayoutReportStep
  }
})
export default class ReportNumberplate extends ReportStepMixin implements IReportStep {
  asset = AssetEnum.vinExmapleOutlined;
  example = AssetEnum.vinExample;

  screen = ReportScreenEnum.numberplate;

  header: IReportHeaderData = {
    title: "report.numberplate.title",
    description: "report.numberplate.description"
  };

  valid = false;

  setValid(value: boolean) {
    this.valid = value;
  }

  get numberplate(): string {
    return ReportModule.numberplate;
  }

  set numberplate(value: string) {
    ReportModule.setNumberplate(value);
  }

  get isDone() {
    return this.valid;
  }

  get countryCode(): CountryCodeEnum {
    return ReportModule.partnerCountryCode;
  }
}
</script>

<style scoped>
.container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.text {
  font-size: 20px;
  padding-left: 20px;
}
</style>
